export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сумма"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Результат"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Транзакция"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Обновить статус"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Полезные ссылки"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Блокчейн:"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["В процессе"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успешно"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Неудачно"])}
}